import { cn } from "@/lib/utils";

import type { LucideIcon } from "lucide-react";

export interface IconOption<T extends string> {
  value: T;
  label: string;
  icon: LucideIcon;
}

/** Dokploy-style grid of icon cards, used as a bigger-touch-target
 * alternative to a <Select> when there are only a few options. */
export function IconOptionGrid<T extends string>({
  options,
  value,
  onChange,
  disabled,
}: {
  options: IconOption<T>[];
  value: T;
  onChange: (value: T) => void;
  disabled?: boolean;
}) {
  return (
    <div
      className={cn(
        "grid gap-2",
        options.length <= 2 ? "grid-cols-2" : "grid-cols-3",
      )}
    >
      {options.map(({ value: optionValue, label, icon: Icon }) => {
        const selected = optionValue === value;
        return (
          <button
            key={optionValue}
            type="button"
            disabled={disabled}
            onClick={() => onChange(optionValue)}
            className={cn(
              "flex flex-col items-center gap-1.5 rounded-lg border p-3 text-xs font-medium transition-colors",
              selected
                ? "border-primary bg-primary/5 text-primary"
                : "border-border text-muted-foreground hover:bg-muted",
              disabled && "cursor-not-allowed opacity-50",
            )}
          >
            <Icon className="h-5 w-5" />
            {label}
          </button>
        );
      })}
    </div>
  );
}
